export default {
    headerName: translate("company.Managers"),
    width: 240,
    field: "users",
    sortable: false,
    suppressMenu: true,
    cellRenderer: "UserCellRenderer"
}
